import script from "./TicketEditDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketEditDialog.vue?vue&type=script&setup=true&lang=js"

import "./TicketEditDialog.vue?vue&type=style&index=0&id=7be2e1c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7be2e1c2"]])

export default __exports__